import { render } from "./CFormular.vue?vue&type=template&id=084f1639"
import script from "./CFormular.vue?vue&type=script&lang=js"
export * from "./CFormular.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__